import React, { useEffect, useCallback, useState} from 'react';
import Freeze from './Freeze.js';
import Midi from './Midi.js';
import Audio from './Audio.js';
import ClockOptions from "components/ClockOptions.js";
import Appearance from './Appearance.js';
import {connect} from 'react-redux';
import '../../Settings.scss';

const APPEARANCE = "Appearance";
const MIDI = "MIDI";
const AUDIO = "Audio";
const FREEZE = "Freeze";
const CLOCK = "Clock";

const Settings = (props) => { 
    const [option, setOption] = useState(APPEARANCE);
    return (
        <div className="settings">
          <div className="settings-sidebar">
            <Option option={APPEARANCE} selectedOption={option} setOption={setOption}/>
            {!props.onlyAppearance ? 
             <Option option={MIDI} selectedOption={option} setOption={setOption}/> : ''}
            {!props.onlyAppearance ? 
             <Option option={AUDIO} selectedOption={option} setOption={setOption}/> : ''}
            {!props.onlyAppearance ? 
             <Option option={FREEZE} selectedOption={option} setOption={setOption}/> : ''}
            {!props.onlyAppearance ? 
             <Option option={CLOCK} selectedOption={option} setOption={setOption}/> : ''}
          </div>
          <div className="settings-content">
            {option === APPEARANCE ? <Appearance sequencerEngine={props.sequencerEngine}/> : ''}
            {option === MIDI ? <Midi sequencerEngine={props.sequencerEngine}/> : ''}
            {option === AUDIO ? <Audio sequencerEngine={props.sequencerEngine}/> : ''}
            {option === FREEZE ? <Freeze sequencerEngine={props.sequencerEngine}/> : ''}
            {option === CLOCK ? <ClockOptions sequencerEngine={props.sequencerEngine}/> : ''}
          </div>
        </div>);
};

const Option = ({option, setOption, selectedOption}) => {
    let className = "settings-option";
    if (option === selectedOption) {
        className += " selected";
    }
    return (
        <div onClick={() => setOption(option)} className={className}>
          {option}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
